//ユーザーCSVアップロードページ
import React, { Fragment, useState } from 'react';
import { Typography, Button, Form, message, Input, Select, Spin, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Dropzone from 'react-dropzone';
import Axios from 'axios';
import config from '../../Config/key';
import Papa from 'papaparse';
import {
  decodeCsvBuffer,
  validateCsvHeaders,
  formatHeaderValidationError,
  extractAxiosErrorMessage,
} from '../../../utils/csvUploadHelper';
import {
  B_TYPE_RELATION4_CONFIRM,
  convertBTypeRelation4Rows,
  isBType360,
} from '../../../utils/survey360Relation';
// const bcrypt = require('bcrypt');
// const saltRounds = 10;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;

// CSV に必須の列（email + relation）
// relation: 1=本人 / 2=上司 / 3=同僚 / 4=部下
const REQUIRED_COLUMNS = ['email', 'relation'];

const confirmRelation4Conversion = (count) =>
  new Promise((resolve) => {
    Modal.confirm({
      title: '関係の確認',
      content: `${B_TYPE_RELATION4_CONFIRM}（対象 ${count}件）`,
      okText: 'はい（relation=3として登録）',
      cancelText: 'キャンセル',
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });

function CSVRelationUploadPage(props) {
  const [fileData, setFileData] = useState();
  const [fileJSON, setFileJSON] = useState();
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selSurveySeasonId, setSelSurveySeasonId] = useState([]); //選択したシーズンID
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState([]); //選択したシーズン情報
  const [surveySeason, setSurveySeason] = useState([]); //グループにあるサーベイシーズン

  // let department = [];

  // const [projectDescriptionValue, setProjectDescriptionValue] = useState('');
  const [groupCode, setGroupCode] = useState('');
  const [submitButtonDisable, setSubmitButtonDisable] = useState(true);
  // 処理中フラグ（大量件数で待機が長い間、二重送信防止 + 全画面スピナー）
  const [processing, setProcessing] = useState(false);

  const onDrop = async (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading failed');
    reader.onload = (e) => {
      //ファイルの読み込みが終わったら発火
      // decodeCsvBuffer で文字コード自動判定 + 先頭 BOM 除去まで一括処理
      const unicodeString = decodeCsvBuffer(e.target.result);
      Papa.parse(unicodeString, {
        header: true,
        dynamicTyping: false,
        skipEmptyLines: true,
        complete: async (results) => {
          // 必須列の存在検証（email + relation 両方）
          // BOM は decodeCsvBuffer で除去済み、その他不可視文字を捕捉
          const headers = (results.meta && results.meta.fields) || [];
          const v = validateCsvHeaders(headers, REQUIRED_COLUMNS);
          if (!v.ok) {
            message.error({
              content: formatHeaderValidationError(v),
              key: 'csvupload',
              duration: 10,
            });
            setFileJSON(undefined);
            setFileData(
              'エラー：CSVヘッダーを確認の上、再アップロードしてください。'
            );
            return;
          }
          setFileData(unicodeString);
          setFileJSON(results.data);
          //const courseInfo = courseMerge(results.data);
          // setProjectKeyValue(`${courseInfo.course_id}_${ymdhms()}`);
          // console.log({ courseInfo });
        },
      });
    };
    reader.readAsArrayBuffer(file); //ファイルを読み込む
    const group = await Axios.get('/api/group/360FS');
    // const group = await Axios.get('/api/group/40010');
    setGroups(group.data.groups);
    setSubmitButtonDisable(true);
    setGroupCode('');
    setSelSurveySeasonId('');

    // console.log(group.data.groups);
  };

  //yyyymmddhhmmss
  const ymdhms = () => {
    var date = new Date();
    return (
      date.getFullYear() +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      ('0' + date.getDate()).slice(-2) +
      ('0' + date.getHours()).slice(-2) +
      ('0' + date.getMinutes()).slice(-2) +
      ('0' + date.getSeconds()).slice(-2)
      // date.getMilliseconds()
    );
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setProcessing(true);
    try {
      message.loading({
        content: 'CSVアップロード中...（件数が多い場合は時間がかかります）',
        key: 'csvupload',
        duration: 0,
      });

      // ── 検証 #1: CSVファイル本体の存在チェック ──
      if (!fileJSON || fileJSON.length === 0) {
        throw new Error(
          'CSVファイルが選択されていないか、データ行が0件です。'
        );
      }

      // ── 検証 #2: CSV必須カラム（email, relation）の存在チェック ──
      const firstRow = fileJSON[0];
      if (!('email' in firstRow) || !('relation' in firstRow)) {
        throw new Error(
          'CSVに必須カラム（email, relation）が含まれていません。'
        );
      }

      // ── 検証 #3, #4: 各行のemail/relation値チェック ──
      fileJSON.forEach((row, idx) => {
        const rowNo = idx + 2; // ヘッダー行を1としたデータ行番号
        const emailRaw = (row.email || '').trim();
        if (!emailRaw || !emailRaw.includes('@')) {
          throw new Error(
            `行 ${rowNo}: メールアドレスが空または不正です。`
          );
        }
        if (!['1', '2', '3', '4'].includes(row.relation)) {
          throw new Error(
            `行 ${rowNo}: relationの値が不正です（1/2/3/4 のいずれか）。値: '${row.relation}'`
          );
        }
      });

      // ── 検証 #5: 本人(relation=1)行が0件 ──
      const heroRows = fileJSON.filter((item) => item.relation === '1');
      if (heroRows.length === 0) {
        throw new Error('本人（relation=1）の行が含まれていません。');
      }

      // ── 検証 #6: 先頭行が本人(relation=1)であること ──
      // ※ 先頭が協力者だと「本人未確定」のまま協力者処理に入り、hInfoがundefinedになる
      if (fileJSON[0].relation !== '1') {
        throw new Error(
          `先頭行は本人（relation=1）である必要があります。現在: 行2 relation=${fileJSON[0].relation}`
        );
      }

      // ── 検証 #7: 本人emailの重複 ──
      const heroEmail = heroRows.map((item) => item.email);
      const dupHero = heroEmail.filter(
        (email, idx) => heroEmail.indexOf(email) !== idx
      );
      if (dupHero.length > 0) {
        throw new Error(
          `本人が重複しています: ${[...new Set(dupHero)].join(', ')}`
        );
      }

      // ── 検証 #8: 本人が自身の協力者にも入っている ──
      let hero = '';
      fileJSON.forEach((element) => {
        if (element.relation === '1') {
          hero = element.email;
        }
        if (
          (element.relation === '2' ||
            element.relation === '3' ||
            element.relation === '4') &&
          element.email === hero
        ) {
          throw new Error(
            `本人が協力者の中に入っています: ${element.email}`
          );
        }
      });

      // ── 検証 #8b: 同一hero内で協力者emailが重複 ──
      let currentHeroEmail = '';
      const heroEvaluators = {};
      fileJSON.forEach(function (element) {
        if (element.relation === '1') {
          currentHeroEmail = element.email;
          if (!heroEvaluators[currentHeroEmail]) {
            heroEvaluators[currentHeroEmail] = new Set();
          }
        } else if (
          element.relation === '2' ||
          element.relation === '3' ||
          element.relation === '4'
        ) {
          if (
            heroEvaluators[currentHeroEmail] &&
            heroEvaluators[currentHeroEmail].has(element.email)
          ) {
            throw new Error(
              `${currentHeroEmail}の協力者に${element.email}が重複しています。`
            );
          }
          if (heroEvaluators[currentHeroEmail]) {
            heroEvaluators[currentHeroEmail].add(element.email);
          }
        }
      });

      // ── サーバーからグループユーザー取得 ──
      const res = await Axios.get('/api/users/group/' + groupCode);
      const groupUser = res.data.users;

      // ── 検証 #9: CSVのメールアドレスがグループに登録済みか ──
      const groupEmailSet = new Set(groupUser.map((u) => u.email));
      const missingEmails = [
        ...new Set(
          fileJSON
            .map((row) => row.email)
            .filter((email) => !groupEmailSet.has(email))
        ),
      ];
      if (missingEmails.length > 0) {
        const shown = missingEmails.slice(0, 5).join(', ');
        const tail =
          missingEmails.length > 5
            ? ` 他 ${missingEmails.length - 5}件`
            : '';
        throw new Error(
          `該当グループに登録されていないメールアドレスがあります: ${shown}${tail}`
        );
      }

      // ── 検証 #10, #11: シーズンの設問セット(sub_type=4/5)割当チェック ──
      // ※ map内でfindしていたものを外出し（一度だけ評価＋エラーメッセージ明確化）
      // １シーズンでは１typeの問題セットのみがアサインされる前提(6x6,6x5,5x6,cup)
      const heroQSet = (selSurveySeasonInfo.question_set || []).find(
        (item) => item.sub_type === '4'
      );
      if (!heroQSet) {
        throw new Error(
          '選択したサーベイシーズンに本人用の設問セット（sub_type=4）が割り当てられていません。シーズン編集画面で設問セットを設定してください。'
        );
      }
      const aroundQSet = (selSurveySeasonInfo.question_set || []).find(
        (item) => item.sub_type === '5'
      );
      if (!aroundQSet) {
        throw new Error(
          '選択したサーベイシーズンに協力者用の設問セット（sub_type=5）が割り当てられていません。シーズン編集画面で設問セットを設定してください。'
        );
      }
      const hero_question = heroQSet._id;
      const around_question = aroundQSet._id;

      // Bタイプは本人/上司/部下・同僚の3区分。relation=4 が含まれる場合は、
      // 利用者の確認を得たうえで relation=3 へ正規化してから登録する。
      const type360 = aroundQSet.type_360 || heroQSet.type_360;
      const relation4Count = fileJSON.filter(
        (row) => row.relation === '4'
      ).length;
      let registrationRows = fileJSON;
      if (isBType360(type360) && relation4Count > 0) {
        const confirmed = await confirmRelation4Conversion(relation4Count);
        if (!confirmed) {
          message.info({
            content: 'CSVアップロードをキャンセルしました。',
            key: 'csvupload',
            duration: 3,
          });
          return;
        }
        registrationRows = convertBTypeRelation4Rows(fileJSON);
      }

      // ── 検証 #12: シーズンに既に登録済みの本人とCSVの本人が重複 ──
      const heroId = heroEmail.map(
        (email) => groupUser.find((item) => item.email === email)?._id
      );
      const inHeroId = (selSurveySeasonInfo.relation_360 || []).map(
        (element) => element.user_id
      );
      const dupExisting = [];
      heroId.forEach((id, idx) => {
        if (inHeroId.includes(id)) {
          dupExisting.push(heroEmail[idx]);
        }
      });
      if (dupExisting.length > 0) {
        throw new Error(
          `登録対象の本人が既にシーズンに存在します: ${dupExisting.join(', ')}`
        );
      }

      // ── データ加工：本人ごとにboss/partner/sub をまとめて relation360 と surveyToken を生成 ──
      let sendData = [];
      let tempData = {};
      let sendToken = [];
      let boss = [];
      let partner = [];
      let sub = [];
      let hInfo = '';

      registrationRows.forEach((record) => {
        const sendDate = new Date();
        let expire = new Date();
        expire = expire.setDate(expire.getDate() + 60);
        const tempToken = {
          user: groupUser.find((item) => item.email === record.email)?._id,
          survey_id: selSurveySeasonInfo.survey_id,
          survey_code: selSurveySeasonInfo.survey_code,
          token_make_date: sendDate,
          token_expire: expire,
          token_valid: sendDate,
          survey_status: 0,
          group_code: groupCode,
          survey_season_id: selSurveySeasonId,
        };

        switch (record.relation) {
          case '1': // 本人の場合
            if (tempData.survey_season_id) {
              // 次の本人に切り替わるタイミングで、直前の本人分をflush
              tempData.boss = boss;
              tempData.partner = partner;
              tempData.sub = sub;
              sendData.push(tempData);
              tempData = {};
              boss = [];
              partner = [];
              sub = [];
            }
            // 本人データの格納
            hInfo = groupUser.find((item) => item.email === record.email);
            tempData = {
              survey_season_id: selSurveySeasonId,
              user_id: hInfo?._id,
              group_code: groupCode,
            };
            tempToken.question_set_id = hero_question;
            tempToken.hero_id = hInfo?._id;
            tempToken.hero_name = hInfo.lastname + ' ' + hInfo.name;
            tempToken.relation = 1;
            break;

          case '2': // 上司の場合
            boss.push(
              groupUser.find((item) => item.email === record.email)?._id
            );
            tempToken.question_set_id = around_question;
            tempToken.hero_id = hInfo?._id;
            tempToken.hero_name = hInfo.lastname + ' ' + hInfo.name;
            tempToken.relation = 2;
            break;

          case '3': // 部下・同僚の場合(従来), 同僚の場合(SS)
            partner.push(
              groupUser.find((item) => item.email === record.email)?._id
            );
            tempToken.question_set_id = around_question;
            tempToken.hero_id = hInfo?._id;
            tempToken.hero_name = hInfo.lastname + ' ' + hInfo.name;
            tempToken.relation = 3;
            break;

          case '4': // 部下の場合(SS)
            sub.push(
              groupUser.find((item) => item.email === record.email)?._id
            );
            tempToken.question_set_id = around_question;
            tempToken.hero_id = hInfo?._id;
            tempToken.hero_name = hInfo.lastname + ' ' + hInfo.name;
            tempToken.relation = 4;
            break;

          default:
            break;
        }
        sendToken.push(tempToken);
      });
      // 最後の本人分をflush
      tempData.boss = boss;
      tempData.partner = partner;
      tempData.sub = sub;
      sendData.push(tempData);

      const [res2, res3] = await Promise.all([
        Axios.post('/api/relation360', sendData),
        Axios.post('/api/surveyToken/ticket', sendToken),
      ]);

      if (res2.data.success && res3.data.success) {
        setFileData('CSVアップロードが完了しました。');
        message.success({
          content: 'アップロード完了！',
          key: 'csvupload',
          duration: 3,
        });
        setTimeout(() => {
          props.history.push('/');
        }, 1000);
      } else {
        message.error({
          content: 'CSVアップロードに失敗しました。',
          key: 'csvupload',
          duration: 3,
        });
        throw new Error('CSVアップロードに失敗しました。');
      }
    } catch (error) {
      console.log({ error });
      // バックエンドの具体的なエラー本文を抽出して表示（運用担当が pm2 logs 参照不要）
      // throw new Error(...) で投げた事前検証エラーは error.message にフォールバックして同等表示
      message.error({
        content: extractAxiosErrorMessage(
          error,
          'CSVアップロードに失敗しました。'
        ),
        key: 'csvupload',
        duration: 5,
      });
    } finally {
      setProcessing(false);
    }
  };

  const onChangeGroup = (value) => {
    if (value) {
      setGroupCode(value);
      setSubmitButtonDisable(true);
      const ssi = groups.find(
        (item) => item.group_code === value
      ).survey_season;
      setSurveySeason(ssi);
      setSelSurveySeasonId('');
      // console.log({ ssi });
    }
    // console.log(e);
  };

  const onChangeSurveySeason = (value) => {
    if (value) {
      setSelSurveySeasonId(value);
      setSelSurveySeasonInfo(surveySeason.find((item) => item._id === value));
      setSubmitButtonDisable(false);
      // console.log({ value });
    }
  };

  return (
    <Fragment>
      <Spin
        spinning={processing}
        fullscreen
        tip="処理中です。完了までこのままお待ちください…"
      />
      <div style={{ maxWidth: '700px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>360, BSFS 関係情報 CSV アップロード</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* Drop zone */}
            <Dropzone onDrop={onDrop} multiple={false} maxSize={1000000000}>
              {({ getRootProps, getInputProps }) => (
                <div
                  style={{
                    width: '300px',
                    height: '240px',
                    border: '1px solid lightgray',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <PlusOutlined style={{ fontSize: '3rem' }} />
                </div>
              )}
            </Dropzone>
            <div
              style={{
                width: '300px',
                height: '240px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Text mark>
                CSVファイルをDrag &
                Dropするか、+を押してファイルを選択してください。
              </Text>
            </div>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            {/* <Text strong>企業コードを入力してください（必須）</Text>
            <Input
              placeholder="一意になる企業コードを入力してください。"
              allowClear
              onChange={onChangeGroupCode}
              value={groupCode}
            /> */}
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>企業を選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="企業選択"
                optionFilterProp="children"
                onChange={onChangeGroup}
                value={groupCode}
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {groups.map((element) => {
                  // console.log({ element });
                  return (
                    <Option value={element.group_code} key={element._id}>
                      {element.group_name}
                    </Option>
                  );
                })}
              </Select>
            </div>
            <br />
          </div>
          <br />
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
            {/* <Text strong>企業コードを入力してください（必須）</Text>
            <Input
              placeholder="一意になる企業コードを入力してください。"
              allowClear
              onChange={onChangeGroupCode}
              value={groupCode}
            /> */}
            <Text strong>サーベイシーズンを選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="サーベイシーズン選択"
                optionFilterProp="children"
                onChange={onChangeSurveySeason}
                value={selSurveySeasonId}
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {surveySeason.map((element) => {
                  if (
                    element.survey_code === '40010' ||
                    element.survey_code === '60020'
                  ) {
                    return (
                      <Option value={element._id} key={element._id}>
                        {element.season_name}
                      </Option>
                    );
                  } else {
                    return;
                  }
                  // console.log({ element });
                })}
              </Select>
            </div>
            <br />
          </div>
          <br />
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❹</Title>
          <Button
            type="primary"
            size="large"
            onClick={onSubmit}
            disabled={submitButtonDisable || processing}
            loading={processing}
          >
            アップロード
          </Button>
        </Form>
        <TextArea rows={20} value={fileData} />
      </div>
    </Fragment>
  );
}

export default CSVRelationUploadPage;
